<template>
  <b-alert v-show="personDocument || hasRestrictions " :personDocument="personDocument" :show="dismissCountDown" dismissible variant="danger" :fade="true"
    @dismissed="resetData = 0" @dismiss-count-down="countDownChanged">
    ATENÇÃO! O associado pode conter restrições.
  </b-alert>
</template>
<script>
import AssociateRepository from '@/shared/http/repositories/business/associate.js'

export default {
  name: 'RestrictionAlert',
  props: {
    personDocument: {
      type: String,
      default: null
    },
    hasRestrictions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted () {
    if (this.personDocument !== null) this.warnRestrictions(this.personDocument)
    if (this.hasRestrictions) this.dismissCountDown = this.dismissSecs
  },
  watch: {
    personDocument: function (newPersonDocument, oldPersonDocument) {
      this.warnRestrictions(newPersonDocument)
    }
  },
  methods: {
    resetData () {
      this.dismissCountDown = 0
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    warnRestrictions (personDocument) {
      AssociateRepository.GetByDocument(personDocument)
        .then((response) => {
          if (response.data.content[0]) {
            let pendencias = response.data.content[0].pendencias
            if (!pendencias) return

            let { notificado, ajuizado, cobranca, impeditivaAbsoluta } = pendencias

            this.dismissCountDown = (notificado || ajuizado || cobranca || impeditivaAbsoluta) ? this.dismissSecs : 0
          }
        })

        .catch((e) => {
          console.error(e)
          this.dismissCountDown = 0
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UI/restrictionAlert/restrictionAlert.vue